import React, { Component } from "react";
import 'react-inputs-validation/lib/react-inputs-validation.min.css';
import { LOGIN_TYPE_ADMIN,GetSettingURL,CLIENT_LIST} from "./helper/Constants";
import Apihelpers from "./helper/ApiHelper";
//import $ from "jquery";
import { reactLocalStorage } from "reactjs-localstorage";
import UnAuthorised from "./UnAuthorised";
import moment from 'moment';
import Header from "./include/Header";
import { Link } from "react-router-dom";


class SettingView extends Component {
  constructor(props) {
    super(props);
    this.state = {
        rc_prime_bulk_upload_source_order:[],
        rc_prime_bulk_upload_owndb_cache_days:0,

        mobile_rc_bulk_upload_source_order:[],
        mobile_rc_bulk_upload_owndb_cache_days:0,
        mobile_rc_bulk_upload_limit:0,

        challan_bulk_upload_source_order:[],
        challan_bulk_upload_owndb_cache_days:0,

        rc_prime_reverse_api_source_order:[],
        rc_prime_reverse_owndb_cache_days_for_Api:0,

        rc_prime_api_source_order:[],
        rc_prime_owndb_cache_days_for_Api:0,
        monthly_client_wise_rcprime_api_hit_cc_email:[],

        zeta_auth_token:"",

        rc_challan_owndb_cache_days_for_Api:0,
        fcm_challan_cron_cache_days:0,
        fcm_challan_cron_interval_days:0,

        rcPrimeChallan_prime_owndb_cache_days:0,
        rcPrimeChallan_challan_owndb_cache_days:0,

        panFetch_owndb_cache_days:0,
        aadhaarFetch_owndb_cache_days:0,

        fcm_insurance_cron_interval_days:0,
        fcm_insurance_cron_expire_notify_days:0,

        fcm_pucc_cron_interval_days:0,
        fcm_pucc_cron_expire_notify_days:0,
        

        bbuser_auto_renewal_exprie_token_cc_email: [],
        bbuser_auto_renewal_exprie_token_days_interval:0,
        bbuser_auto_renewal_token_notify_expire_days:0, 
        bbuser_business_unit_options:[],

        aadhaarFetch_mail_notify_email:[],

        vehicle_service_history_sentemail_enable:false,
        //vehicle_service_history_sentmail_bbusers:[],
        vehicle_service_history_sentemail_list: [],
        free_rc_api_hit_source_order: [],

        challan_api_hit_source_order: [],
        fcm_challan_api_hit_source_order: [],

        rcPrimeChallan_prime_source_order:[],
        rcPrimeChallan_challan_source_order:[],

        token_expire_days:0,

        unlink_file_days:0,

        api_source_call_timeout:0,
        api_source_call_retry_timeout:0,
        api_source_call_timeout_advanceForgery:0,
        api_source_call_timeout_aadhaarFetch:0,

        rate_limit_mmv_hit:0,
        rate_limit_mmv_duration:0,
        rate_limit_rcprime_hit:0,
        rate_limit_rcprime_duration:0,
        rate_limit_default_hit:0,
        rate_limit_default_duration:0,

        //clientList:[],

        dbOptimizStartDate:null,
        dbOptimizEndDate:null,
        dbOptimizApiTypes:[],
        dbOptimizSelectedSource:[],
        dbOptimizSelectedReason:[]
    }
  }
  componentDidMount() {
    //this.loadClientListDetail();
    this.get_Data_Of_Setting();
    //if (reactLocalStorage.get("login_type") === LOGIN_TYPE_ADMIN) {}
  }
  get_Data_Of_Setting = () => {
    Apihelpers.getdataresponse(GetSettingURL).then(res => {
      var data = res.data.data;
      console.log('data',data);
      this.setState({
        rc_prime_bulk_upload_source_order:data.rc_prime_bulk_upload_source_order,
        rc_prime_bulk_upload_owndb_cache_days:data.rc_prime_bulk_upload_owndb_cache_days,

        mobile_rc_bulk_upload_source_order:data.mobile_rc_bulk_upload_source_order,
        mobile_rc_bulk_upload_owndb_cache_days:data.mobile_rc_bulk_upload_owndb_cache_days,
        mobile_rc_bulk_upload_limit:data.mobile_rc_bulk_upload_limit,

        challan_bulk_upload_source_order:data.challan_bulk_upload_source_order,
        challan_bulk_upload_owndb_cache_days:data.challan_bulk_upload_owndb_cache_days,

        rc_prime_reverse_api_source_order:data.rc_prime_reverse_api_source_order,
        rc_prime_reverse_owndb_cache_days_for_Api:data.rc_prime_reverse_owndb_cache_days_for_Api,

        rc_prime_api_source_order:data.rc_prime_api_source_order,
        rc_prime_owndb_cache_days_for_Api:data.rc_prime_owndb_cache_days_for_Api,
        monthly_client_wise_rcprime_api_hit_cc_email:data.monthly_client_wise_rcprime_api_hit_cc_email.split(","),

        zeta_auth_token:data.zeta_auth_token,

        rc_challan_owndb_cache_days_for_Api:data.rc_challan_owndb_cache_days_for_Api,
        fcm_challan_cron_cache_days:data.fcm_challan_cron_cache_days,
        fcm_challan_cron_interval_days:data.fcm_challan_cron_interval_days,

        rcPrimeChallan_prime_owndb_cache_days:data.rcPrimeChallan_prime_owndb_cache_days,
        rcPrimeChallan_challan_owndb_cache_days:data.rcPrimeChallan_challan_owndb_cache_days,

        panFetch_owndb_cache_days:data.panFetch_owndb_cache_days,
        aadhaarFetch_owndb_cache_days:data.aadhaarFetch_owndb_cache_days,

        fcm_insurance_cron_interval_days:data.fcm_insurance_cron_interval_days,
        fcm_insurance_cron_expire_notify_days:data.fcm_insurance_cron_expire_notify_days,

        fcm_pucc_cron_interval_days:data.fcm_pucc_cron_interval_days,
        fcm_pucc_cron_expire_notify_days:data.fcm_pucc_cron_expire_notify_days,

        bbuser_auto_renewal_exprie_token_cc_email:data.bbuser_auto_renewal_exprie_token_cc_email.split(","),
        bbuser_auto_renewal_exprie_token_days_interval:data.bbuser_auto_renewal_exprie_token_days_interval,
        bbuser_auto_renewal_token_notify_expire_days:data.bbuser_auto_renewal_token_notify_expire_days, 
        bbuser_business_unit_options:data.bbuser_business_unit_options || [],

        aadhaarFetch_mail_notify_email:data.aadhaarFetch_mail_notify_email?.split(","),
        
        vehicle_service_history_sentemail_enable:data.vehicle_service_history_sentemail_enable,
        //vehicle_service_history_sentmail_bbusers:data.vehicle_service_history_sentmail_bbusers,
        vehicle_service_history_sentemail_list:data.vehicle_service_history_sentemail_list.split(","),

        free_rc_api_hit_source_order:data.free_rc_api_hit_source_order,

        challan_api_hit_source_order:data.challan_api_hit_source_order,
        fcm_challan_api_hit_source_order:data.fcm_challan_api_hit_source_order,

        rcPrimeChallan_prime_source_order:data.rcPrimeChallan_prime_source_order,
        rcPrimeChallan_challan_source_order:data.rcPrimeChallan_challan_source_order,

        api_source_call_timeout:data.api_source_call_timeout,
        api_source_call_retry_timeout:data.api_source_call_retry_timeout,
        api_source_call_timeout_advanceForgery:data.api_source_call_timeout_advanceForgery,
        api_source_call_timeout_aadhaarFetch:data.api_source_call_timeout_aadhaarFetch,

        rate_limit_mmv_hit:data.rate_limit_mmv_hit,
        rate_limit_mmv_duration:data.rate_limit_mmv_duration,
        rate_limit_rcprime_hit:data.rate_limit_rcprime_hit,
        rate_limit_rcprime_duration:data.rate_limit_rcprime_duration,
        rate_limit_default_hit:data.rate_limit_default_hit,
        rate_limit_default_duration:data.rate_limit_default_duration,

        token_expire_days:data.token_expire_days,

        unlink_file_days:data.unlink_file_days,

        dbOptimizStartDate: data.dbOptimizStartDate,
        dbOptimizEndDate: data.dbOptimizEndDate,
        dbOptimizApiTypes: data.dbOptimizApiTypes,
        dbOptimizSelectedSource: data.dbOptimizSelectedSource,
        dbOptimizSelectedReason: data.dbOptimizSelectedReason,
      });
    });
  }
//   loadClientListDetail() {
//     var clientListForInternal=[];
//     Apihelpers.getdataresponse(CLIENT_LIST).then(res => {
//       if (res.data.status === true) {
//         var client_list=res.data.data[0]["clientist"];
//         //console.log('client_list',client_list);
//         var result=client_list.map((values,index)=>{
//            clientListForInternal[values.bbuserInfo[0]._id]= values.bbuserInfo[0].business_name;
//           let client_display_name=values.bbuserInfo[0].business_name+" ("+values.bbuserInfo[0]._id+")";
//           return {key:index,id:values.bbuserInfo[0]._id,text:client_display_name}
//         });
//         this.setState({
//           clientList: result,
//         });
//         console.log('clientList',this.state.clientList);
//       }
//       //console.log('clientListForInternal', clientListForInternal);
//     });
//   }
  render() {
    if (reactLocalStorage.get("login_type") === LOGIN_TYPE_ADMIN) {
      return (
        <React.Fragment>
          <div className="wrapper settingPage">
            <Header />
            <div className="container">
              <div className="whiteBox">
                <div className="titleRow">
                    <div className="row align-items-center">
                        <div className="col">
                            <h3 className="title">Settings</h3>
                        </div>
                        <div className="col-auto">
                            <Link to={"/admin/setting-edit/"}><i className="fa fa-edit"></i> Edit Settings</Link>
                        </div>
                    </div>
                </div>
                <div className="settingViewBlock">
                    <h4 className="subhading">RCExcel Service</h4>
                    <div className="row">
                        <div className="col-md-4">
                            <div className="infoRow">
                                <div className="key">RCExcel bulk upload source order: </div>
                                <div className="val">
                                    {this.state.rc_prime_bulk_upload_source_order.join(', ')}
                                </div>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="infoRow">
                                <div className="key">RCExcel Bulk Upload Own Database Cache Days: </div>
                                <div className="val">{this.state.rc_prime_bulk_upload_owndb_cache_days} Days</div>
                            </div>
                        </div>
                    </div>
                    <h4 className="subhading">Mobile RC Excel Service</h4>
                    <div className="row">
                        <div className="col-md-4">
                            <div className="infoRow">
                                <div className="key">Mobile RC Excel bulk upload source order: </div>
                                <div className="val">
                                    {this.state.mobile_rc_bulk_upload_source_order.join(', ')}
                                </div>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="infoRow">
                                <div className="key">Mobile RC Excel Bulk Upload Own Database Cache Days: </div>
                                <div className="val">{this.state.mobile_rc_bulk_upload_owndb_cache_days} Days</div>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="infoRow">
                                <div className="key">Mobile RC Excel Bulk Upload Limit: </div>
                                <div className="val">{this.state.mobile_rc_bulk_upload_limit} Limit</div>
                            </div>
                        </div>
                    </div>
                    <h4 className="subhading">Challan Excel Service</h4>
                    <div className="row">
                        <div className="col-md-4">
                            <div className="infoRow">
                                <div className="key">Challan Excel bulk upload source order: </div>
                                <div className="val">
                                    {this.state.challan_bulk_upload_source_order.join(', ')}
                                </div>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="infoRow">
                                <div className="key">Challan Excel Bulk Upload Own Database Cache Days: </div>
                                <div className="val">{this.state.challan_bulk_upload_owndb_cache_days} Days</div>
                            </div>
                        </div>
                    </div>
                    <h4 className="subhading">RCPrime Service</h4>
                    <div className="row">
                        <div className="col-md-4">
                            <div className="infoRow">
                                <div className="key">RC Prime API Source Order: </div>
                                <div className="val">{this.state.rc_prime_api_source_order.join(', ')}</div>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="infoRow">
                                <div className="key">RC Prime Own Database Cache Days: </div>
                                <div className="val">{this.state.rc_prime_owndb_cache_days_for_Api} Days</div>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="infoRow">
                                <div className="key">Monthly Client-Wise RC-Prime & Challan Api Hits CC Email: </div>
                                <div className="val">{this.state.monthly_client_wise_rcprime_api_hit_cc_email.join(', ')}</div>
                            </div>
                        </div>
                    </div>
                    <h4 className="subhading">RCPrime Reverse Service</h4>
                    <div className="row">
                        <div className="col-md-4">
                            <div className="infoRow">
                                <div className="key">RCPrime Reverse source order: </div>
                                <div className="val">
                                    {this.state.rc_prime_reverse_api_source_order.join(', ')}
                                </div>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="infoRow">
                                <div className="key">RCPrime Reverse Own Database Cache Days: </div>
                                <div className="val">{this.state.rc_prime_reverse_owndb_cache_days_for_Api} Days</div>
                            </div>
                        </div>
                    </div>
                    <h4 className="subhading">RC Service</h4>
                    <div className="row">
                        <div className="col-md-6">
                            <div className="infoRow">
                                <div className="key">RC API Source Order: </div>
                                <div className="val">{this.state.free_rc_api_hit_source_order.join(', ')}</div>
                            </div>
                        </div>
                    </div>
                    <h4 className="subhading">Vehicle Challan Service</h4>
                    <div className="row">
                        <div className="col-md-6">
                            <div className="infoRow">
                                <div className="key">Challan API Source Order: </div>
                                <div className="val">{this.state.challan_api_hit_source_order.join(', ')}</div>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="infoRow">
                                <div className="key">Vehicle Challan Own Database Cache Days: </div>
                                <div className="val">{this.state.rc_challan_owndb_cache_days_for_Api} Days</div>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="infoRow">
                                <div className="key">FCM Challan Cron Database Cache Days: </div>
                                <div className="val">{this.state.fcm_challan_cron_cache_days} Days</div>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="infoRow">
                                <div className="key">FCM Challan Cron User Interval Days: </div>
                                <div className="val">{this.state.fcm_challan_cron_interval_days} Days</div>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="infoRow">
                                <div className="key">FCM Challan API Source Order: </div>
                                <div className="val">{this.state.fcm_challan_api_hit_source_order.join(', ')}</div>
                            </div>
                        </div>
                    </div>
                    <h4 className="subhading">Vehicle Combo Service</h4>
                    <div className="row">
                        <div className="col-md-6">
                            <div className="infoRow">
                                <div className="key">Combo Prime Api Source Order: </div>
                                <div className="val">{this.state.rcPrimeChallan_prime_source_order.join(', ')}</div>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="infoRow">
                                <div className="key">Combo Prime Api Own Database Cache Days: </div>
                                <div className="val">{this.state.rcPrimeChallan_prime_owndb_cache_days} Days</div>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="infoRow">
                                <div className="key">Combo Challan Api Source Order: </div>
                                <div className="val">{this.state.rcPrimeChallan_challan_source_order.join(', ')}</div>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="infoRow">
                                <div className="key">Combo Challan Api Own Database Cache Days: </div>
                                <div className="val">{this.state.rcPrimeChallan_challan_owndb_cache_days} Days</div>
                            </div>
                        </div>
                    </div>
                    <h4 className="subhading">Vehicle Insurance Service</h4>
                    <div className="row">
                        <div className="col-md-4">
                            <div className="infoRow">
                                <div className="key">FCM Insurance Cron User Interval Days: </div>
                                <div className="val">{this.state.fcm_insurance_cron_interval_days} Days</div>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="infoRow">
                                <div className="key">FCM Insurance Cron User Expire Reminder Days: </div>
                                <div className="val">{this.state.fcm_insurance_cron_expire_notify_days} Days</div>
                            </div>
                        </div>
                    </div>
                    <h4 className="subhading">Vehicle PUCC Service</h4>
                    <div className="row">
                        <div className="col-md-4">
                            <div className="infoRow">
                                <div className="key">FCM PUCC Cron User Interval Days: </div>
                                <div className="val">{this.state.fcm_pucc_cron_interval_days} Days</div>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="infoRow">
                                <div className="key">FCM PUCC Cron User Expire Reminder Days: </div>
                                <div className="val">{this.state.fcm_pucc_cron_expire_notify_days} Days</div>
                            </div>
                        </div>
                    </div>
                    <h4 className="subhading">Documents Verfication Service</h4>
                    <div className="row">
                        <div className="col-md-4">
                            <div className="infoRow">
                                <div className="key">Pan Fetch Own DB Cache Days: </div>
                                <div className="val">{this.state.panFetch_owndb_cache_days} Days</div>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="infoRow">
                                <div className="key">Aadhaar Fetch Own DB Cache Days: </div>
                                <div className="val">{this.state.aadhaarFetch_owndb_cache_days} Days</div>
                            </div>
                        </div>
                    </div>
                    <h4 className="subhading">BBUser Auto Renewal Token</h4>
                    <div className="row">
                        <div className="col-md-4">
                            <div className="infoRow">
                                <div className="key">Bbuser Auto Renewal Exprie Token CC Email: </div>
                                <div className="val valB">{this.state.bbuser_auto_renewal_exprie_token_cc_email.join(', ')}</div>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="infoRow">
                                <div className="key">Bbuser Business Unit Options: </div>
                                <div className="val valB">{this.state.bbuser_business_unit_options.join(', ')}</div>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="infoRow">
                                <div className="key">Bbuser Auto Renewal Exprie Token Days Interval: </div>
                                <div className="val">{this.state.bbuser_auto_renewal_exprie_token_days_interval} Days</div>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="infoRow">
                                <div className="key">Bbuser Auto Renewal Token Notify Expire Days: </div>
                                <div className="val">{this.state.bbuser_auto_renewal_token_notify_expire_days} Days</div>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="infoRow">
                                <div className="key">Aadhaar Fetch Mail Notify Email: </div>
                                <div className="val valB">{this.state.aadhaarFetch_mail_notify_email?.join(', ')}</div>
                            </div>
                        </div>
                    </div>
                    <h4 className="subhading">Vehicle Service History</h4>
                    <div className="row">
                        <div className="col-md-4">
                            <div className="infoRow">
                                <div className="key">Vehicle Service History Sent Email: </div>
                                <div className="val valB">
                                    {this.state.vehicle_service_history_sentemail_enable ? ('Enable') : ('Disable')}
                                </div>
                            </div>
                        </div>
                        {/* <div className="col-md-4">
                            <div className="infoRow">
                                <div className="key">Vehicle Service History Sent Email Bbusers: </div>
                                <div className="val valB">
                                    {
                                        this.state.vehicle_service_history_sentmail_bbusers?.map(client=> {
                                            let index = this.state.clientList.findIndex(item => item.id === client);
                                            return(
                                                <span>{
                                                    this.state.clientList[index] ? this.state.clientList[index].text : null
                                                    }<br /></span>
                                            )
                                        })
                                    }
                                </div>
                            </div>
                        </div> */}
                        <div className="col-md-4">
                            <div className="infoRow">
                                <div className="key">Vehicle Service History & RC-Prime Sent To Email List: </div>
                                <div className="val valB">{this.state.vehicle_service_history_sentemail_list.join(', ')}</div>
                            </div>
                        </div>
                    </div>
                    <h4 className="subhading">API Source Setting</h4>
                    <div className="row">
                        <div className="col-md-6">
                            <div className="infoRow">
                                <div className="key">API Source TimeOut: </div>
                                <div className="val">{this.state.api_source_call_timeout} Seconds</div>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="infoRow">
                                <div className="key">API Source Retry TimeOut: </div>
                                <div className="val">{this.state.api_source_call_retry_timeout} Seconds</div>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="infoRow">
                                <div className="key">API Source TimeOut For AdvanceForgery: </div>
                                <div className="val">{this.state.api_source_call_timeout_advanceForgery} Seconds</div>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="infoRow">
                                <div className="key">API Source TimeOut For AadhaarFetch: </div>
                                <div className="val">{this.state.api_source_call_timeout_aadhaarFetch} Seconds</div>
                            </div>
                        </div>
                        
                    </div>
                    <h4 className="subhading">Dashboard Setting</h4>
                    <div className="row">
                        <div className="col-md-4">
                            <div className="infoRow">
                                <div className="key">Token Expire Days: </div>
                                <div className="val">{this.state.token_expire_days} Days</div>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="infoRow">
                                <div className="key">Unlink File Days: </div>
                                <div className="val">{this.state.unlink_file_days} Days</div>
                            </div>
                        </div>
                    </div>
                    <h4 className="subhading">Rate Limit Setting</h4>
                    <div className="row">
                        <div className="col-md-6">
                            <div className="infoRow">
                                <div className="key">MMV API Per Hit: </div>
                                <div className="val">{this.state.rate_limit_mmv_hit} Per Hit</div>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="infoRow">
                                <div className="key">MMV API Per Second: </div>
                                <div className="val">{this.state.rate_limit_mmv_duration} Seconds</div>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="infoRow">
                                <div className="key">RC Prime API Per Hit: </div>
                                <div className="val">{this.state.rate_limit_rcprime_hit} Per Hit</div>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="infoRow">
                                <div className="key">RC Prime API Per Second: </div>
                                <div className="val">{this.state.rate_limit_rcprime_duration} Seconds</div>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="infoRow">
                                <div className="key">Default API Per Hit: </div>
                                <div className="val">{this.state.rate_limit_default_hit} Per Hit</div>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="infoRow">
                                <div className="key">Default API Per Second: </div>
                                <div className="val">{this.state.rate_limit_default_duration} Seconds</div>
                            </div>
                        </div>
                        
                    </div>
                    <h4 className="subhading">Authentication Token</h4>
                    <div className="row">
                    <div className="col-md-12">
                        <div className="infoRow">
                           <div className="key">Zeta Auth Token: </div>
                           <div className="val">{this.state.zeta_auth_token}</div>
                        </div>
                      </div>
                    </div>
                    <h4 className="subhading">DB Optimization Query Settings</h4>
                    <div className="row">
                        <div className="col-md-4">
                            <div className="infoRow">
                                <div className="key">Start Date: </div>
                                <div className="val">{(this.state.dbOptimizStartDate) ? moment(this.state.dbOptimizStartDate).format('LL') : '--'}</div>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="infoRow">
                                <div className="key">End Date (Exclusive): </div>
                                <div className="val">{(this.state.dbOptimizEndDate) ? moment(this.state.dbOptimizEndDate).format('LL') : '--'}</div>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="infoRow">
                                <div className="key">API Type: </div>
                                <div className="val">{(this.state.dbOptimizApiTypes.length> 0) ? this.state.dbOptimizApiTypes.join(', ') : '--'}</div>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="infoRow">
                                <div className="key">Source: </div>
                                <div className="val">{(this.state.dbOptimizSelectedSource.length> 0) ? this.state.dbOptimizSelectedSource.join(', ') : '--'}</div>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="infoRow">
                                <div className="key">Reason: </div>
                                <div className="val">{(this.state.dbOptimizSelectedReason.length> 0) ? this.state.dbOptimizSelectedReason.join(', ') : '--'}</div>
                            </div>
                        </div>
                    </div>
                    

                    <div className="text-center">
                        <Link to={"/admin/setting-edit/"} className="blueBtn">Edit Settings</Link>
                    </div>
                </div>
              </div>
            </div>
          </div>
          <div className="loader" style={{ display: "none" }}>
            <div className="bg"></div>
            <img className="loadingImg" src="/assets/images/loading.gif" alt="" />
          </div>
        </React.Fragment>
      )
    } else {
      return (
        <UnAuthorised></UnAuthorised>
      )
    }
  }
}

export default SettingView;
